import { render, staticRenderFns } from "./BroadcastCommands.vue?vue&type=template&id=02c1a479"
import script from "./BroadcastCommands.vue?vue&type=script&lang=ts"
export * from "./BroadcastCommands.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports